<template>
  <div>
      <PricingFilterToolbar
        :search-term="searchTerm"
        :expired-filter="expiredFilter"
        search-placeholder="Search (Description, Contract Term)..."
        @search-change="searchTerm = $event"
        @expired-filter-change="expiredFilter = $event"
      >
        <template v-slot:actions>
          <button v-if="userEditRight" type="button" @click="addNewPackage" class="btn btn-info mr-3 mb-2">
            Add New Package
          </button>
        </template>
        <template v-slot:before-search>
          <div class="form-group mb-2 mr-3 package-type-filter" v-if="pricingRouteName === 'fttbpricing'">
            <span class="mr-2">Package type</span>
            <v-select
              :options="packageTypes"
              v-model="packageTypeSelected"
            >
            </v-select>
          </div>
        </template>
      </PricingFilterToolbar>
      <div class="table-responsive table-bordered" v-if="packages.length > 0 && packageSalesData.length > 0">
        <table class="table pricing-table" ref="table">
          <thead>
            <tr class="text-nowrap">
              <th class="table-font-size pricing-column-description">Description</th>
              <th class="table-font-size pricing-column-label">Label</th>
              <th class="table-font-size pricing-column-price">NRC (excl. VAT)</th>
              <th class="table-font-size pricing-column-price">MRC (excl. VAT)</th>
              <th class="table-font-size pricing-column-price">MRC (incl. VAT)</th>
              <th class="table-font-size pricing-column-status">Expired</th>
              <th class="table-font-size pricing-column-services">Services</th>
              <th class="table-font-size pricing-column-id">#</th>
              <th class="table-font-size pricing-column-actions"></th>
            </tr>
          </thead>
          <tbody>
            <tr :class="{ 'bg-primary': connectivityPackage.expired }" v-for="connectivityPackage in packages" :key="connectivityPackage.connectivityPackageNumber">
              <td>
                <strong>
                  <span class="font-size">{{ connectivityPackage.description }}</span>
                </strong>
              </td>
              <td class="pricing-column-label">
                <strong>
                  <span class="font-size">{{ connectivityPackage.label }}</span>
                </strong>
              </td>
              <td class="text-nowrap">
                <span class="font-size">{{ getSetupFee(connectivityPackage.connectivitypackageprices, period) }}</span>
              </td>
              <td>
                <span class="font-size">{{ getPrice(connectivityPackage.connectivitypackageprices, period) }}</span>
                <span v-if="userEditRight" style="cursor: pointer" @click="openPriceModal(connectivityPackage)" v-tooltip="'Edit Row Price'" class="pull-right">
                  <em class="fa fa-edit fa-fw text-green"></em>
                </span>
              </td>
              <td class="text-nowrap">
                <span class="font-size">{{ getPrice(connectivityPackage.connectivitypackageprices, period, true) }}</span>
              </td>
              <td>
                <span class="badge" :class="connectivityPackage.expired ? 'badge-warning' : 'badge-green'">{{ connectivityPackage.expired }}</span>
              </td>
              <td class="text-nowrap text-center">
                <strong>
                  <span class="font-size">{{ servicesAmount(connectivityPackage) }}</span>
                </strong>
              </td>
              <td class="text-center">
                <span class="font-size">{{ connectivityPackage.connectivityPackageNumber }}</span>
              </td>
              <td class="text-center">
                <button v-if="userEditRight" v-tooltip="'Edit Package'" @click="editPackage(connectivityPackage)" type="button" class="btn btn-sm btn-info m-1">
                  <em class="fa fa-edit fa-fw"></em>
                </button>
                <button v-if="userEditRight" v-tooltip="'Delete Package'" @click="deletePackage(connectivityPackage)" type="button" class="btn btn-sm btn-primary">
                  <em class="fa fa-trash fa-fw"></em>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else class="alert alert-info">No Prices Available to Display</div>
      <ModifyUncappedPackageModal
        ref="modifyPackageModal"
        :pricePackage="pricePackage"
        :shapedPools="shapedPools"
        :contractTerms="contractTerms"
        @packageAdded="packageAdded"
        @packageEdited="$emit('get-connectivity-packages')"
      />
      <AddPriceModal
        ref="addPriceModal"
        :row-price="rowPrice"
        :new-price="newPrice"
        :package-description="packageDescription"
        @addPrice="addPrice"
        @pricesAdded="$emit('get-connectivity-packages')"
      />
  </div>
</template>

<script>
import PriceFunctions from "@/components/Admin/PriceFunctions";
import ModifyUncappedPackageModal from "@/components/Admin/Modals/ModifyUncappedPackageModal";
import AddPriceModal from "@/components/Admin/Modals/AddPriceModal";
import PricingFilterToolbar from "@/components/Admin/PricingFilterToolbar";
export default {
  extends: PriceFunctions,
  props: {
    connectivityPackages: {
      type: Array,
      required: true,
    },
    productNumber: {
      type: Number,
      required: true,
    },
    emptyPackage: {
      type: Object,
      required: true,
    },
    userEditRight: {
      type: Boolean,
      required: true
    },
  },
  components: {
    ModifyUncappedPackageModal,
    AddPriceModal,
    PricingFilterToolbar,
  },
  data() {
    return {
      period: this.getCurrentPeriod(),
      rowPrice: [],
      shapedPools: [],
      contractTerms: [],
      pricePackage: {},
      newPrice: {},
      expiredFilter: "false",
      filteredPackages: [],
      packageSalesData: [],
      packageSales: null,
      searchTerm: '',
      getPackageSaleAmounts: true,
      packageTypes: ["Internet Access", "Add-on", "MPLS"],
      packageTypeSelected: "Internet Access",
      pricingRouteName: null,
      productDetail: {},
      packageDescription: '',
    };
  },
  watch: {
    searchTerm(newVal, oldVal) {      
      if (oldVal !== newVal) {
        this.getPackageSaleAmounts = false;
      } 
    },
    expiredFilter(newVal, oldVal) {
      if (newVal !== oldVal && !this.getPackageSaleAmounts) {
        this.getPackageSaleAmounts = true;
      }
    }
  },
  computed: {
    packages() {        
      if (this.expiredFilter === "true") {
        this.filteredPackages = this.connectivityPackages.filter(p => p.expired === true && p.type === this.packageTypeSelected);
      } else if (this.expiredFilter === "both") {
        this.filteredPackages = this.connectivityPackages.filter(p => p.type === this.packageTypeSelected);
      } else {
        this.filteredPackages = this.connectivityPackages.filter(p => (p.expired === false) && p.type === this.packageTypeSelected); 
      }
      this.searchPackages(this.searchTerm); 
      this.getServiceAmounts(this.filteredPackages);        
      return this.filteredPackages;
    },
  },
  mounted() {   
    this.getShapedPools();
    this.getContractTerms();
    this.getExistingProduct();
  },
  methods: {
    getExistingProduct: function() {
        const hostUrl = this.$config.aimsAPI;
        const productNumber = this.productNumber;        

        this.$http.get(`${hostUrl}products/${productNumber}`).then(
          (response) => {
            this.productDetail = response.data; 
            const productDefinitionMetaData = this.getProductDefinition(this.productDetail.productDefinition);
            this.pricingRouteName = productDefinitionMetaData.pricingRouteName;
        },
        (error) => {
            console.error(error);
            this.showError("Error Fetching Product", error);
        });
    },
    getShapedPools: function() {
      const hostUrl = this.$config.aimsAPI;

      this.$http.get(`${hostUrl}shapedpools`).then(
        (response) => {
          this.shapedPools = response.data;
        },
        (error) => {
          this.showError("Error fetching Shaped Pools", error);
          console.error(error);
        }
      );
    },
    getContractTerms: function() {
      const hostUrl = this.$config.aimsAPI;

        this.$http.get(`${hostUrl}pricing/contractterms`).then(
        (response) => {
          this.contractTerms = response.data;
        },
        (error) => {
          this.showError("Error fetching Contract Terms", error);
          console.error(error);
        }
      );
    },
    getServiceAmounts: function(data) {     
      const hostUrl = this.$config.aimsAPI;  
      
      if (!this.searchTerm || this.getPackageSaleAmounts) {
        this.$http.post(`${hostUrl}pricing/linkedservices/amount`, data).then(
          (response) => {
            this.packageSalesData = response.data;      
          },
          (error) => {
            this.showError("Error fetching package sales data", error);
            console.error(error);
          }
        );        
      }
    },
    servicesAmount: function(packageData) {
      let saleAmount;        
      this.packageSalesData.filter(data => {
        if (data.connectivityPackageNumber === packageData.connectivityPackageNumber) {
          saleAmount = data.sales;
        }
      });   
      return saleAmount;
    },
    addNewPackage: function() {
      this.pricePackage = this.deepCopyObject(this.emptyPackage);

      if (this.pricingRouteName === "fttbpricing") {
        this.pricePackage.type = this.packageTypeSelected;
      }

      this.$refs.modifyPackageModal.open();
    },
    editPackage: function(connectivityPackage) {
      this.pricePackage = this.deepCopyObject(connectivityPackage);
      this.$refs.modifyPackageModal.open();
    },
    packageAdded: function(connectivityPackage) {
      connectivityPackage.connectivitypackageprices = [];
      connectivityPackage.shapedpool = this.shapedPools.find(
        (sp) => sp.shapedPoolNumber == connectivityPackage.shapedPoolNumber
      );
      this.connectivityPackages.push(connectivityPackage);
      this.openPriceModal(connectivityPackage);
    },
    setNewPrice: function() {
      this.newPrice = this.deepCopyObject(
        this.emptyPackage.connectivitypackageprice
      );
    },
    openPriceModal: function(connectivityPackage) {
      this.setNewPrice();
      this.rowPrice = this.deepCopyObject(
        connectivityPackage.connectivitypackageprices
      );
      this.packageDescription = connectivityPackage.description || '';
      this.newPrice.connectivityPackageNumber =
        connectivityPackage.connectivityPackageNumber;
      this.$refs.addPriceModal.open();
    },
    addPrice: function(newPrice) {
      this.rowPrice.forEach((price) => {
        if (price.validUntil == 0) {
          if (newPrice.validFrom % 100 > 1) {
            price.validUntil = newPrice.validFrom - 1;
          } else {
            price.validUntil = newPrice.validFrom - 100 + 11;
          }
        }
      });
      this.rowPrice.push(newPrice);
      this.setNewPrice();
      this.newPrice.connectivityPackageNumber =
        newPrice.connectivityPackageNumber;
    },
    deletePackage: function(connectivityPackage) {
      this.$swal({
        title: "Are you sure you want to delete this price package?",
        type: "warning",
        showCancelButton: true,
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.value) {
          const hostUrl = this.$config.aimsAPI;

          this.$http.delete(`${hostUrl}pricing/pricepackages/${connectivityPackage.objKey}?objClassName=${connectivityPackage.class}`).then(
              (response) => {
                this.showSuccess(response.data.message);
                this.$emit("get-connectivity-packages");
              },
              (error) => {
                this.showError("Error Deleting Price Package", error);
              }
            );
        }
      });
    },
    speedBitsToMbits: function(value) {
      if (value && value > 0) {
        return value / 1000000;
      } else {
        return 0;
      }
    },
    searchPackages: function(searchTerm) {
      if (searchTerm) {
          this.filteredPackages = this.filteredPackages.filter(p => p.description.toLowerCase().includes(searchTerm.toLowerCase()) || p.contractTerm.toLowerCase().includes(searchTerm.toLowerCase()));
      }
    },
  },
};
</script>

<style scoped>
.package-type-filter {
  white-space: nowrap;
}

th.table-font-size {
  font-size: .95rem;
}
th.table-header-width-1 {
  width: 10px;
}
th.table-header-width-2 {
  width: 20px;
}
th.table-header-width-3 {
  width: 50px;
}
th.table-header-width-4 {
  width: 60px;
}
th.table-header-width-5 {
  width: 95px;
}
th.table-header-width-6 {
  width: 200px;
}

.font-size {
  font-size: .9rem;
}
</style>
